import { render, staticRenderFns } from "./Messages.vue?vue&type=template&id=d00e53c2&scoped=true&"
import script from "@/views/Users/Student/Messages.ts?vue&type=script&lang=ts&"
export * from "@/views/Users/Student/Messages.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Users/Student/messages.scss?vue&type=style&index=0&id=d00e53c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00e53c2",
  null
  
)

export default component.exports